<template>
    <div id="button">
        <div
            :style="{
                'background-color': bgColor,
                padding: `${paddingY} 0px`,
                border: border,
                borderRadius: borderRadius,
            }"
            :class="`container ${size === 'large' ? 'large' : size}  ${active ? '' : 'deactive'}`"
            @click="btnClickHandler()"
        >
            <div :style="{ color: txtColor }" class="button">
                <slot />
            </div>
        </div>
    </div>
</template>
<script>
export const enumSize = Object.freeze({
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
});

export default {
    name: "Button",
    props: {
        txtColor: { type: String, default: "black" },
        paddingY: { type: String, default: "15px" },
        border: { type: String, default: "none" },
        borderRadius: { type: String, default: "0px" },
        bgColor: { type: String, default: "#ec4b1d" },
        size: {
            validator(value) {
                if (Object.values(enumSize).includes(value)) {
                    return value;
                }
            },
            default: enumSize.LARGE,
        },
        active: { type: Boolean, default: true},
    },
    data() {
        return {};
    },
    methods: {
        btnClickHandler() {
            if (this.active) {
                this.$emit("btnClicked");
            }
        },
    },
    mounted(){
    },
};
</script>
<style lang="scss">
#button {
    width: 100%;

    .container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        cursor: pointer;
        user-select: none;
        overflow: hidden;

        &.medium {
            width: 50%;
        }

        &.small {
            width: 30%;
        }

        &.deactive {
            user-select: none;
            cursor: no-drop;
            filter: blur(1px) brightness(102%) saturate(0%);
            -webkit-filter: blur(1px) brightness(102%) saturate(0%);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/common/Button.vue